<div *ngIf="projects$ | async">
    <div class="d-flex align-items-center">
        <div class="w-100">
            <app-searchbar
                (valueChange)="applyFilter($event)"
                [(value)]="filter"></app-searchbar>
        </div>
        <div class="d-flex nowrap">
            <app-global-export-csv
                [componentName]="this.constructor.name"
                [exporter]="exporter"
                class="m-l-2"></app-global-export-csv>
        </div>
    </div>

    <div class="m-t-2" *ngIf="jiraProjectsLoaded">
        <div class="message message--warning" *ngIf="jiraMissingProjects.length > 0">
            <strong>New projects found in Jira:</strong> {{ jiraMissingProjects.length }}
            <button type="button" class="button button--outline button--small m-l-2" (click)="openMissingJiraProjectsPopup()">Show list</button>
        </div>
        <div class="message message--success" *ngIf="jiraMissingProjects.length === 0">
            No new projects found in Jira.
        </div>
    </div>
    
    <div class="m-t-4">
        <div class="table__overflow">
            <table
                #exporter="matTableExporter"
                [dataSource]="dataSource"
                mat-table
                matSort
                matSortActive="title"
                matSortDirection="asc"
                matTableExporter>
                <ng-container matColumnDef="eye">
                    <th
                        *matHeaderCellDef
                        mat-header-cell
                        width="1">
                        <i class="las la-eye"></i>
                    </th>
                    <td
                        *matCellDef="let row"
                        class="td-icon"
                        mat-cell>
                        <span
                            *ngIf="row.finished"
                            class="tag tag--green"
                            >Finished</span
                        >
                        <span
                            *ngIf="!row.finished"
                            class="tag tag--blue"
                            >Ongoing</span
                        >
                    </td>
                </ng-container>

                <ng-container matColumnDef="title">
                    <th
                        *matHeaderCellDef
                        mat-header-cell
                        mat-sort-header>
                        Title
                    </th>
                    <td
                        *matCellDef="let row"
                        mat-cell>
                        <app-pill-project [project]="row"></app-pill-project>
                        <div class="project-date-range">{{ getProjectDateRangeLabel(row) }}</div>
                    </td>
                </ng-container>


                <ng-container matColumnDef="endDateWorklogs">
                    <th
                        *matHeaderCellDef
                        mat-header-cell
                        mat-sort-header>
                        Budget by worklogs
                    </th>
                    <td
                        *matCellDef="let row"
                        mat-cell>
                        <ng-container *ngIf="isOverviewBudgetLoading(row); else overviewBudgetLoaded">
                            <i class="fa fa-spinner fa-spin"></i>
                        </ng-container>
                        <ng-template #overviewBudgetLoaded>
                        <div class="budget-worklog-actions" *ngIf="row.hasAccounts">
                            <button
                                type="button"
                                class="button button--icon button--small budget-refresh-btn"
                                [disabled]="isOverviewBudgetLoading(row)"
                                (click)="loadOverviewWorklogs(row, $event)"
                                [title]="isOverviewBudgetLoading(row) ? 'Loading worklogs...' : 'Fetch worklogs'">
                                <i class="las" [ngClass]="isOverviewBudgetLoading(row) ? 'la-spinner la-spin' : 'la-sync-alt'"></i>
                            </button>
                        </div>
                        <ng-container *ngIf="showContractBudgetProgress(row); else noContractProgress">
                            <ng-container *ngIf="getOverviewBudgetStatuses(row).length > 0">
                                <div *ngFor="let status of getOverviewBudgetStatuses(row)" class="budget-status-row">
                                    <div class="budget-status-row__label">{{ status.label || 'Contract/account' }}</div>
                                    <div>
                                        € {{ (status.amount ?? 0) | number: '1.2-2' }} / € {{ (status.budget ?? 0) | number: '1.2-2' }}
                                    </div>
                                    <div class="progress"
                                        [matTooltip]="getContractBudgetStatusTooltip(status)"
                                        matTooltipPosition="above"
                                        matTooltipClass="budget-tooltip">
                                        <mat-progress-bar
                                            [value]="getContractBudgetStatusProgressBarValue(status)"
                                            [ngClass]="{'warning': getContractBudgetStatusUsagePercentage(status) >= 70, 'danger': getContractBudgetStatusUsagePercentage(status) >= 90}"
                                            mode="determinate">
                                        </mat-progress-bar>
                                    </div>
                                    <small>
                                        {{ getContractBudgetStatusUsagePercentage(status) | number: '1.0-2' }}%
                                        <span *ngIf="getContractBudgetStatusUsagePercentage(status) > 100">(over budget)</span>
                                    </small>
                                </div>
                            </ng-container>
                        </ng-container>
                        <ng-template #noContractProgress></ng-template>
                        </ng-template>
                    </td>
                </ng-container>

                <ng-container matColumnDef="endDateInvoice">
                    <th
                        *matHeaderCellDef
                        mat-header-cell
                        mat-sort-header>
                        Budget by invoice
                    </th>
                    <td
                        *matCellDef="let row"
                        mat-cell>
                        <ng-container *ngIf="showInvoiceBudgetProgress(row); else noInvoiceBudgetProgress">
                            <div class="budget-status-row">
                                <div>
                                    € {{ getBudgetByInvoiceAmount(row) | number: '1.2-2' }} / € {{ getResolvedContractBudget(row) | number: '1.2-2' }}
                                </div>
                                <div class="progress"
                                    [matTooltip]="getBudgetByInvoiceTooltip(row)"
                                    matTooltipPosition="above"
                                    matTooltipClass="budget-tooltip">
                                    <mat-progress-bar
                                        [value]="getBudgetByInvoiceProgressBarValue(row)"
                                        [ngClass]="{'warning': getBudgetByInvoiceUsagePercentage(row) >= 70, 'danger': getBudgetByInvoiceUsagePercentage(row) >= 90}"
                                        mode="determinate">
                                    </mat-progress-bar>
                                </div>
                                <small>
                                    {{ getBudgetByInvoiceUsagePercentage(row) | number: '1.0-2' }}%
                                    <span *ngIf="getBudgetByInvoiceUsagePercentage(row) > 100">(over budget)</span>
                                </small>
                            </div>
                        </ng-container>
                        <ng-template #noInvoiceBudgetProgress>-</ng-template>
                    </td>
                </ng-container>
                <ng-container matColumnDef="warranty">
                    <th
                        *matHeaderCellDef
                        mat-header-cell
                        mat-sort-header>
                        Warranty
                    </th>
                    <td
                        *matCellDef="let row"
                        mat-cell>
                        <div *ngIf="!hasWarranty(row)">
                            <i class="las la-times-circle"style="color: red">
                            </i>
                        </div>
                        <div *ngIf="!hasActiveWarrantyDates(row)"><span id="expired"><b>EXPIRED</b></span> {{row.warrantyStartDate | date}} - {{row.warrantyEndDate | date}}</div>
                        <div *ngIf="hasActiveWarrantyDates(row) && hasWarranty(row) && calculateRemainingWarrantyDays(row) == 0"><span id="expiring"><b>EXPIRING TODAY</b></span>
                            {{ row.warrantyStartDate | date }} - {{ row.warrantyEndDate | date }}
                        </div>
                        <div *ngIf="hasActiveWarrantyDates(row) && hasWarranty(row) && calculateRemainingWarrantyDays(row) > 0"><span id="active"><b>{{calculateRemainingWarrantyDays(row)}}</b><b> DAYS REMAINING</b></span>
                            {{ row.warrantyStartDate | date }} - {{ row.warrantyEndDate | date }}
                        </div>
                    </td>
                </ng-container>
                <ng-container matColumnDef="maintenanceContract">
                    <th
                        *matHeaderCellDef
                        mat-header-cell
                        mat-sort-header>
                        Maintenance Contract
                    </th>
                    <td
                        *matCellDef="let row"
                        mat-cell>
                        <div *ngIf="!hasMaintenanceContract(row)">
                            <i class="las la-times-circle" style="color: red"></i>
                        </div>
                        <div *ngIf="hasMaintenanceContract(row)">
                                <i class="las la-check" style="color: green"></i>
                        </div>
                    </td>
                </ng-container>
                <ng-container matColumnDef="researchDevelopment">
                    <th
                        *matHeaderCellDef
                        mat-header-cell
                        mat-sort-header>
                        O&amp;O
                    </th>
                    <td
                        *matCellDef="let row"
                        class="td-icon"
                        mat-cell>
                        <div *ngIf="isResearchDevelopmentEligible(row); else notResearchDevelopmentEligible">
                            <i class="las la-check" style="color: green"></i>
                        </div>
                        <ng-template #notResearchDevelopmentEligible>
                            <i class="las la-times-circle" style="color: red"></i>
                        </ng-template>
                    </td>
                </ng-container>
                <ng-container matColumnDef="comanageContact">
                    <th
                        *matHeaderCellDef
                        mat-header-cell
                        mat-sort-header>
                        Comanage contact
                    </th>
                    <td
                        *matCellDef="let row"
                        mat-cell>
                        <ng-container *ngIf="row.comanageContactId; else noCoManageContact">
                            {{ getCoManageContactDisplay(row.comanageContactId) }}
                        </ng-container>
                        <ng-template #noCoManageContact>-</ng-template>
                    </td>
                </ng-container>
                <ng-container matColumnDef="businessDeveloper">
                    <th
                        *matHeaderCellDef
                        mat-header-cell
                        mat-sort-header>
                        Business developer
                    </th>
                    <td
                        *matCellDef="let row"
                        mat-cell>
                        {{ getBusinessDeveloperDisplay(row) }}
                    </td>
                </ng-container>
                <ng-container matColumnDef="projectType">
                    <th
                        *matHeaderCellDef
                        mat-header-cell
                        mat-sort-header>
                        Type
                    </th>
                    <td
                        *matCellDef="let row"
                        mat-cell>
                        <span class="tag">{{ row.projectType }}</span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="jiraLink">
                    <th
                        *matHeaderCellDef
                        mat-header-cell
                        mat-sort-header>
                        Linked with Jira
                    </th>
                    <td
                        *matCellDef="let row"mat-cell>
                        <div *ngIf="!row.jiraProjectId">
                            <i class="las la-times-circle" style="color: red"></i>
                        </div>
                        <div *ngIf="row.jiraProjectId" class="jira-link-cell">
                            <i class="las la-check" style="color: green"></i>
                            <span class="jira-key" *ngIf="getJiraKeyForProject(row)">{{ getJiraKeyForProject(row) }}</span>
                        </div>
                </td>
                </ng-container>
                <ng-container matColumnDef="creatorId">
                    <th
                        *matHeaderCellDef
                        mat-header-cell
                        mat-sort-header>
                        Creator
                    </th>
                    <td
                        *matCellDef="let row"
                        mat-cell>
                        <app-pill-user
                            *ngIf="row.userId"
                            [userId]="row.userId"></app-pill-user>
                    </td>
                </ng-container>

                <ng-container matColumnDef="edit">
                    <th
                        *matHeaderCellDef
                        class="td-small"
                        mat-header-cell></th>
                    <td
                        *matCellDef="let row"
                        class="td-icon"
                        mat-cell>
                        <span ngbDropdown>
                            <button
                                (click)="$event.stopPropagation()"
                                class="button button--icon button--dropdown button--small"
                                ngbDropdownToggle></button>
                            <span
                                aria-labelledby="dropdownMenuButton"
                                class="dropdown-menu dropdown-menu-right"
                                ngbDropdownMenu>
                                <a
                                    (click)="toggleFinishedProject(row); $event.stopPropagation()"
                                    *appIsPermitted="{ module: 'WORKS', operator: 'AND', actions: ['EDIT'] }"
                                    class="dropdown-item">
                                    <div *ngIf="row.finished; else elseDropDownBlock">Mark as Ongoing</div>
                                    <ng-template #elseDropDownBlock>Mark as Finished</ng-template>
                                </a>
                                <a
                                    (click)="openProjectUpdateModal(row); $event.stopPropagation()"
                                    *appIsPermitted="{ module: 'WORKS', operator: 'AND', actions: ['EDIT'] }"
                                    class="dropdown-item"
                                    >Edit project</a
                                >
                                <a
                                    (click)="downloadProjectPdf(row); $event.stopPropagation()"
                                    *appIsPermitted="{ module: 'WORKS', operator: 'AND', actions: ['READ'] }"
                                    class="dropdown-item"
                                    >Export PDF</a
                                >
                                <a
                                    (click)="openCustomerPortal(); $event.stopPropagation()"
                                    *appIsPermitted="{ module: 'WORKS', operator: 'AND', actions: ['READ'] }"
                                    class="dropdown-item"
                                    >Via Dashboard</a
                                >
                                <div class="dropdown-divider"></div>
                                <a
                                    (click)="openProjectDeleteModal(row); $event.stopPropagation()"
                                    *appIsPermitted="{ module: 'WORKS', operator: 'AND', actions: ['DELETE'] }"
                                    class="dropdown-item color--red">
                                    <ng-container *ngIf="!row.archived; else unarchive">Archive</ng-container>
                                    <ng-template #unarchive>Unarchive</ng-template>
                                </a>
                            </span>
                        </span>
                    </td>
                </ng-container>

                <tr
                    *matHeaderRowDef="displayedColumns"
                    mat-header-row></tr>
                <tr
                    (click)="openProjectInfoModal(row.uuid); $event.stopPropagation()"
                    *matRowDef="let row; columns: displayedColumns"
                    class="pointer"
                    mat-row></tr>

                <tr *matNoDataRow>
                    <td [attr.colspan]="displayedColumns.length">No projects found...</td>
                </tr>
            </table>
        </div>
    </div>
</div>
